"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.SimpleAsyncCallbacks = void 0;
var features_1 = require("../../features");
Object.defineProperty(exports, "SimpleAsyncCallbacks", { enumerable: true, get: function () { return features_1.SimpleAsyncCallbacks; } });
//# sourceMappingURL=index.js.map